import type { MouseEvent } from "react";
import { ButtonBase, Typography, useTheme } from "@mui/material";
import { MoneyField } from "../../fields/MoneyField";
import { Column } from "../../misc/Column";
import type { DrivingSchoolServiceType } from "../../providers/drivingSchoolServiceTypesProvider";

export function ServiceTypeMobileListItem(props: {
  serviceType: DrivingSchoolServiceType;
  onClick?: (event: MouseEvent<HTMLDivElement>) => void;
}) {
  const { serviceType, onClick } = props;
  const theme = useTheme();
  const hasPrice = typeof serviceType.price === "number" && Number.isFinite(serviceType.price);

  return (
    <ButtonBase
      component="div"
      disabled={!onClick}
      onClick={onClick}
      role={onClick ? "button" : undefined}
      tabIndex={onClick ? 0 : undefined}
      sx={{
        alignItems: "stretch",
        borderBottom: `1px solid ${theme.palette.divider}`,
        boxSizing: "border-box",
        display: "block",
        px: 0,
        py: 1,
        textAlign: "left",
        width: "100%",
        "&.Mui-disabled": {
          color: "inherit",
        },
      }}
    >
      <Column sx={{ alignItems: "flex-start", gap: 0.5, minWidth: 0 }}>
        <Typography variant="body1" sx={{ fontWeight: 600, overflowWrap: "anywhere" }}>
          {serviceType.title}
        </Typography>
        <Typography variant="caption" color="text.secondary">
          {serviceType.vatRate} % MwSt.
        </Typography>
        {hasPrice && (
          <Typography variant="caption" color="text.secondary">
            Standardpreis: <MoneyField record={serviceType} source="price" variant="caption" />
          </Typography>
        )}
      </Column>
    </ButtonBase>
  );
}
